// window.mazeUpdateCartAttributes = () => {
//     const customAttribute = getCookie('_Test_Page_visited');
//     console.log('customAttribute',customAttribute);
//     if (customAttribute){
// var formData = new FormData();
//     formData.append("attributes[_Test_Page_visited]", true);
//     fetch(window.Shopify.routes.root + 'cart/update.js', {
//       method: 'POST',
//       body: formData
//     })
//     .then(response => response.json())
//     .finally(() => {
//         console.clear();
//       console.log('Cart attribute added')
//     });
// }
//   }


// document.addEventListener("DOMContentLoaded", (event) => { 
//     console.clear();
// if (getCookie('_Test_Page_visited')) {
//     console.log("Tested");
//     // console.log(getCookie('__Test_Page_visited'));
//     window.mazeUpdateCartAttributes();
// }
// })

// Add to cart Function for Product Card 
window.addToCartById = async function (variantId) {
  if (!variantId) return;

  try {
    const url = `/cart/add.js`;

    const body = {
      id: variantId,
      quantity: 1,
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error("Failed to add item to cart");
    }

    const data = await response.json();
    console.log("Product added", data);

    if (window.cartDrawer) {
      window.cartDrawer.open();
    }

    if (typeof window.refreshCart === "function") {
      window.refreshCart();
    }

  } catch (error) {
    console.error("Add to cart error:", error);
  }
};

document.addEventListener('DOMContentLoaded', () => {

let productCardAtcButtons = document.querySelectorAll(".recovery-submit-btn, .--button-atc");

productCardAtcButtons.forEach((button) => {

  button.addEventListener("click", (e) => {
    e.preventDefault();
    
    let id = Number(button.dataset.id);

    window.addToCartById(id);
  });
});


})



// View More button Toggle 

window.viewMoreSlides=(sectionId,button,visibleSlides=3,event)=>{
  event?.preventDefault();

  if(window.innerWidth>768)return;

  const swiperEl=document.querySelector(`.swiper-${sectionId}`);
  const swiper=swiperEl?.swiper;

  if(swiper&&!swiper.destroyed)swiper.destroy(true,true);

  const slides=swiperEl?.querySelectorAll('.swiper-slide');
  if(!slides?.length)return;

  const expanded=button?.classList.toggle('is-expanded')||false;

  slides.forEach((slide,index)=>{
    slide.classList.toggle('hidden',index>=visibleSlides&&!expanded);
  });

  if(button)button.textContent=expanded?'View Less':'View More';
};